module.exports = __webpack_public_path__ + "static/img/how3.a535658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/how3.png
// module id = ZLPT
// module chunks = 1